import { render, staticRenderFns } from "./JoinClass.vue?vue&type=template&id=1ee725ce&scoped=true&"
import script from "./JoinClass.vue?vue&type=script&lang=js&"
export * from "./JoinClass.vue?vue&type=script&lang=js&"
import style0 from "./JoinClass.vue?vue&type=style&index=0&id=1ee725ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee725ce",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VOverlay,VProgressCircular,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Mihai Racoreanu\\Code\\bodyswaps\\bsportal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ee725ce')) {
      api.createRecord('1ee725ce', component.options)
    } else {
      api.reload('1ee725ce', component.options)
    }
    module.hot.accept("./JoinClass.vue?vue&type=template&id=1ee725ce&scoped=true&", function () {
      api.rerender('1ee725ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/JoinClass.vue"
export default component.exports